import { UserIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAccountsApiClient } from "../../hooks";
import { FilteringDropdown } from "../../ui/Inputs";

interface UserDropdownProps {
    value: number;
    currentUserId?: number;
    company?: number;
    hasApprovalPermission?: boolean;
    onChange: (value: number) => void;
}

export const UserDropdown = (props: UserDropdownProps) => {
    const apiClient = useAccountsApiClient();

    const peopleQuery = useQuery({
        queryKey: [
            "companyUserList",
            props.company,
            props.hasApprovalPermission,
        ],
        queryFn: async () => {
            return await apiClient.accountsUsersList({
                companymembershipCompany: props.company,
                hasApprovalPermission: props.hasApprovalPermission,
            });
        },
    });

    const options = useMemo(() => {
        if (!peopleQuery.data) {
            return [];
        }
        return peopleQuery.data.map((p) => {
            return {
                id: p.id,
                displayName: `${p.firstName} ${p.lastName} (${p.email})`,
                searchString:
                    `${p.firstName} ${p.lastName} ${p.email}`.toLowerCase(),
            };
        });
    }, [peopleQuery.data]);

    const extraActions = [];
    if (
        props.value !== props.currentUserId &&
        peopleQuery.data?.find((u) => u.id === props.currentUserId)
    ) {
        extraActions.push({
            icon: <UserIcon className="h-4 w-4 text-gray-400" />,
            title: "Set myself as responsible",
            action: () => {
                if (peopleQuery.data.length > 0) {
                    props.onChange(props.currentUserId);
                }
            },
        });
    }

    return (
        <FilteringDropdown
            value={props.value}
            onChange={props.onChange}
            options={options}
            extraActions={extraActions}
        />
    );
};
